import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";

function ChartBox(props) {
  const { element, title, prevMonth, thisMonth, legend,filter } = props;
  return (
    <div className="cards h-100">
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="f-20 fw-600">{title}</h3>
        {filter}
        {/* <BsThreeDotsVertical className="c-blue cursur" /> */}
      </div>
      <div>{element}</div>
      {legend ? (
        <div className="d-flex justify-content-center">
          <div className="me-3">
            <p className="f-16 mb-1">
              <span
                className="circle me-2"
                style={{ backgroundColor: "#6842D9" }}
              ></span>
              Previous month
            </p>
            <h5 className="f-16 fw-600 text-center">{prevMonth}</h5>
          </div>
          <div>
            <p className="f-16 mb-1">
              <span
                className="circle me-2"
                style={{ backgroundColor: "#1877F2" }}
              ></span>
              This month
            </p>
            <h5 className="f-16 fw-600 text-center">{thisMonth}</h5>
          </div>
        </div>
      ) : (""
        // <div className="d-flex justify-content-center">
        //   <div className="me-3">
        //     <p className="f-16 mb-1">
        //       <span
        //         className="circle me-2"
        //         style={{ backgroundColor: "#d4d1d185" }}
        //       ></span>
        //       Facebook
        //     </p>
        //     <h5 className="f-16 fw-600 text-center">13%</h5>
        //   </div>
        //   <div>
        //     <p className="f-16 mb-1">
        //       <span
        //         className="circle me-2"
        //         style={{ backgroundColor: "#6842D9" }}
        //       ></span>
        //       Instagram
        //     </p>
        //     <h5 className="f-16 fw-600 text-center">7%</h5>
        //   </div>
        // </div>
      )}
    </div>
  );
}

export default ChartBox;
